<template>
  <v-card
    class="mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Bảng báo cáo giao hàng
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <DeliveryTable
      :data="data"
      :dataTable="dataTable"
    />
    
  </v-card>
</template>

<script>

import DeliveryTable from './DeliveryTable'
import { formatDate } from '@/helpers/utils'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');
const ProductGroupRepository = RepositoryFactory.get('product_group');


import * as moment from 'moment'

  export default {
    components: {
      DeliveryTable
    },
    props: {
      filterForm: {
        default: () => ({})
      },
      dataTable: {
        default: () => ({})
      },
    },
    data () {
      return {
        data: [],
      }
    },
    created() {
      Bus.$on('delivery-status-report-thpt', (filterForm) => {
        this.filterForm = filterForm
        this.search()
      })
    },
    beforeDestroy() {
      Bus.$off('delivery-status-report-thpt')
    },
    methods: {
      search() {
        this.getData()
      },
      async getData() {
        const loader = this.$loading.show()
        const params = {
          startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
          departmentIds: this.filterForm.departmentIds,
          departmentType: 'retail',
          schoolLevelIds: [2]
        };
        // Get data Báo cáo bảng giao hàng
        const response = await ReportRepository.deliveryReportByPerson(params)

        loader.hide()
        if (response.success) {
          this.data = _.get(response, 'data', [])
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }
</style>